/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   deepclone.js (https://stackoverflow.com/a/5344074)
 */

import type { WritableDeep } from 'type-fest'

type ToJSON<T> = T extends null
  ? null
  : T extends { toJSON: () => infer R }
    ? R extends (...args: any) => any
      ? R
      : { [P in keyof R]: ToJSON<R[P]> } | (T & (null | undefined))
    : T extends (...args: any) => any
      ? T
      : { [P in keyof T]: ToJSON<T[P]> }

export const deepclone = <T>(obj: T): WritableDeep<ToJSON<T>> => JSON.parse(JSON.stringify(obj))
